import { COLORS } from '~/themes/common'

const style = {
  quillContainer: {
    '& .ql-toolbar': {
      borderRadius: '5px 5px 0 0',
      borderColor: COLORS.palette.secondaryBlue1,
      border: '0.25px solid',
      paddingTop: 6,
      paddingBottom: 6,
    },
    '& .ql-container': {
      borderRadius: '0 0 5px 5px',
      backgroundColor: COLORS.palette.secondaryBlue3,
      borderColor: COLORS.palette.secondaryBlue1,
      border: '0.25px solid',
    },
    '& .ql-editor': {
      minHeight: 120,
      fontSize: 14,
    },
  },
  error: {
    '& .ql-toolbar': {
      borderColor: '#E05069',
      borderWidth: '1.5px',
    },
    '& .ql-container': {
      borderColor: '#E05069',
      borderWidth: '1.5px',
    },
  },
  disabled: {
    userSelect: 'none',
    pointerEvents: 'none',
    cursor: 'not-allowed',
    '& .ql-toolbar': {
      borderColor: COLORS.gray.disableGray,
      borderBottom: 'none',
    },
    '& .ql-container': {
      borderColor: COLORS.gray.disableGray,
      backgroundColor: COLORS.gray.disableGray2,
    },
  },
  switchContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 8,
    position: 'absolute',
    right: 0,
    top: -26,
  },
  formLabel: {
    textAlign: 'left',
    fontSize: 14,
    letterSpacing: 0,
    color: COLORS.palette.black,
    opacity: 1,
    padding: '4px 0 0 0',
  },
  textArea: {
    flex: 1,
    minHeight: 140,
    width: 'calc(100% - 28px)',
    resize: 'none',
    backgroundColor: COLORS.palette.secondaryBlue3,
    padding: '10px 14px',
    fontSize: 14,
    fontFamily: 'Rubik',
    marginRight: 10,
    borderRadius: 5,
    border: '0.25px solid rgba(0, 0, 0, 0.26)',
    '&:focus': {
      outline: 'none',
    },
    '&::placeholder': {
      fontFamily: 'Rubik',
      color: COLORS.gray.textGray2,
      fontWeight: 300,
    },
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5,
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 10,
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: '#b4bfd9',
    },
  },
}

export default style
